<template>
  <span class="dbc-svg leading-[50%]" v-html="svg" aria-hidden="true" />
</template>

<script setup lang="ts">
const props = defineProps<{
  name: string
}>()

const svg = ref<string | any>('')

watchEffect(async () => {
  try {
    const iconsImport = import.meta.glob('assets/svg/**/**.svg', {
      query: '?raw',
      import: 'default',
      eager: false,
    })
    const rawIcon = await iconsImport[`/assets/svg/${props.name}.svg`]()
    svg.value = rawIcon
  } catch {
    console.error(`[dbc-svg] svg '${props.name}' doesn't exist in 'assets/svg'`)
  }
})
</script>
